import { Check } from "lucide-react";
import { FadeIn, SectionHeader } from "./Reveal";
import { IMAGES } from "../../lib/images";

const POINTS = [
    "Uczciwa wycena — bez ukrytych kosztów",
    "Terminowość potwierdzona na piśmie",
    "Porządek podczas i po zakończeniu prac",
    "Gwarancja na wszystkie wykonane usługi",
];

export default function About() {
    return (
        <section id="o-nas" className="bg-mist py-24 md:py-32">
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 md:px-12 lg:grid-cols-2">
                <FadeIn y={40}>
                    <div className="relative">
                        <div className="absolute -left-4 -top-4 h-32 w-32 rounded-tl-[2.5rem] border-l-4 border-t-4 border-gold" aria-hidden />
                        <div className="overflow-hidden rounded-[2rem] shadow-2xl">
                            <img
                                src={IMAGES.aboutMain}
                                alt="Wnętrze wykończone przez ekipę Handy's"
                                className="h-[440px] w-full object-cover md:h-[560px]"
                                loading="lazy"
                            />
                        </div>
                        <div className="absolute -bottom-8 -right-4 w-44 overflow-hidden rounded-2xl border-8 border-mist shadow-xl md:-right-8 md:w-56">
                            <img
                                src={IMAGES.aboutSmall}
                                alt="Wykończone wnętrze — realizacja Handy's"
                                className="h-40 w-full object-cover md:h-48"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </FadeIn>
                <div>
                    <SectionHeader index="01" eyebrow="O nas" title="Fachowiec, któremu możesz zaufać." />
                    <FadeIn delay={0.15}>
                        <p className="mt-8 text-base leading-relaxed text-ink/60 md:text-lg">
                            Realizujemy zarówno drobne naprawy, jak i kompleksowe remonty mieszkań, domów
                            oraz lokali użytkowych w Krakowie i okolicach. Stawiamy na wysoką jakość wykonania, terminowość
                            i uczciwe podejście do klienta.
                        </p>
                        <p className="mt-5 text-base leading-relaxed text-ink/60">
                            Każde zlecenie — od wymiany gniazdka po remont generalny — traktujemy z tym samym
                            zaangażowaniem. Dlatego klienci wracają i polecają nas dalej.
                        </p>
                    </FadeIn>
                    <ul className="mt-8 space-y-4">
                        {POINTS.map((p, i) => (
                            <FadeIn key={p} delay={0.2 + i * 0.07}>
                                <li className="flex items-center gap-3 text-sm font-medium text-ink md:text-base">
                                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold">
                                        <Check className="h-3.5 w-3.5 text-ink" strokeWidth={3} />
                                    </span>
                                    {p}
                                </li>
                            </FadeIn>
                        ))}
                    </ul>
                    <FadeIn delay={0.45}>
                        <div className="mt-10 border-l-2 border-gold pl-5">
                            <p className="font-display text-xl font-bold tracking-tight text-ink">Jan Białoń</p>
                            <p className="text-sm text-ink/50">właściciel Handy&rsquo;s</p>
                        </div>
                    </FadeIn>
                </div>
            </div>
        </section>
    );
}
